export default (() => {

    const ArrayHasMinimumLength = (minimumLength) => new wealthify.PropValidator('arrayHasMinimumLength', {
        validator: wealthify.type.array.hasMinimumLength,
        customData: minimumLength,
    });
    
    const ArrayObjectContainsKeys = (array) => new wealthify.PropValidator('arrayObjectContainsKeys', {
        validator: (arrayObjects, array) => arrayObjects.every((object) => wealthify.type.object.containsKeys(object, array)),
        customData: array,
    });

    const ObjectContainsKeys = (array) => new wealthify.PropValidator('objectContainsKeys', {
        validator: wealthify.type.object.containsKeys,
        customData: array
    });

    const IsInArray = (array) => new wealthify.PropValidator('isInArray', {
        validator: wealthify.type.array.includes,
        customData: array
    });

    const IsPercent = () => new wealthify.PropValidator('isPercent', {validator: wealthify.type.number.isPercent}
    );

    const IsPositiveNumber = () => new wealthify.PropValidator('isPositiveNumber', {validator: wealthify.type.number.isPositive}
    );

    const IsNegativeNumber = () => new wealthify.PropValidator('isNegativeNumber', {validator: wealthify.type.number.IsNegative}
    );

    const IsTypeArray = () => new wealthify.PropValidator('isTypeArray', {validator: wealthify.type.array.isArray}
    );
    const IsTypeBoolean = () => new wealthify.PropValidator('isTypeBoolean', {validator: wealthify.type.boolean.isBoolean}
    );
    const IsTypeFunction = () => new wealthify.PropValidator('isTypeFunction', {validator: wealthify.type.function.isFunction}
    );
    const IsTypeNumber = () => new wealthify.PropValidator('isTypeNumber', {validator: wealthify.type.number.isNumber}
    );
    const IsTypeObject = () => new wealthify.PropValidator('isTypeObject', {validator: wealthify.type.object.isObject}
    );
    const IsTypeRegex = () => new wealthify.PropValidator('isTypeRegex', {validator: wealthify.regex.isRegex}
    );
    const IsTypeUniqueArray = () => new wealthify.PropValidator('isTypeUniqueArray', {validator: wealthify.type.array.isUniqueArray}
    );

    return {
        ArrayHasMinimumLength,
        ArrayObjectContainsKeys,
        ObjectContainsKeys,
        IsInArray,
        IsPercent,
        IsPositiveNumber,
        IsNegativeNumber,
        IsTypeArray,
        IsTypeBoolean,
        IsTypeFunction,
        IsTypeNumber,
        IsTypeObject,
        IsTypeRegex,
        IsTypeUniqueArray,
    };

})();


